<template lang="html" src='./Login.html'>

</template>

<script>
import McPassword from '@/components/McPassword/McPassword.vue';
import { login, getCourses } from '@/api/index';
import jwtDecode from 'jwt-decode';
import { VERSION_CODE } from '../../utils/constants';

export default {
  name: 'Login',
  components: {
    McPassword,
  },
  data() {
    return {
      mobileVersionLink: process.env.VUE_APP_BASE_URL,
      form: {
        email: '',
        password: '',
      },

      loading: false,
      validation: false,
      versionCode: VERSION_CODE,
    };
  },
  methods: {
    async makeLogin(e) {
      this.loading = true;
      e.preventDefault();

      login(this.form)
        .then(async (data) => {
          if (data.jwt) {
            const decoded = jwtDecode(data.jwt);
            const user = decoded.identity;

            if (user.type_id !== 1) {
              this.$router.push({
                name: 'MfaVerify',
                query: {
                  email: this.form.email,
                  token: data.jwt,
                  menu: JSON.stringify(data.menu),
                },
              });
            } else {
              localStorage.setItem('jwt', data.jwt);
              this.$store.commit('setUser', user);
              const full_menu = [...data.menu];
              this.$store.commit('setFullMenu', full_menu);

              this.$i18n.locale = user.language
                ? user.language
                : this.$i18n.locale;

              this.$store.commit(
                'setMenuPolicy',
                data.menu.sort((a, b) => (a.orden == b.orden ? 0 : a.orden > b.orden ? 1 : -1)),
              );

              console.log('MFA verification successful, redirecting to dashboard.');
              this.$store.commit('setLogged', true);
              this.$router.push(user.type_id !== 1 ? '/company' : 'inventory');
            }
          }
          this.loading = false;
        })
        .catch((e) => {
          this.validation = true;
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./login.scss";
</style>
